/* restriction-option-formatter.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./restriction-option-formatter.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Box, Flex } from '@atlaskit/primitives/compiled';
var styles = {
  optionWrapper: "_11c82smr _syazi7uo"
};
export var restrictionOptionFormatter = function restrictionOptionFormatter(option) {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.optionWrapper
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    gap: "space.100"
  }, option.icon, option.label));
};